import { Navigate } from "react-router-dom";
import { LOGIN } from "../utils/ConstantLinks";
import HomeLayout from "./HomeLayout";
import InactivityLogout from "./InactivityLogout";

// Component for handling protected routes
const ProtectedLayout = () => {
  // Check if the user is logged in, render HomeLayout if true, else navigate to LOGIN page
  return localStorage.accessToken ? <InactivityLogout><HomeLayout /></InactivityLogout> : <Navigate to={LOGIN} />;
};

export default ProtectedLayout;
